/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect, useContext } from 'react';
import 'react-phone-input-2/lib/style.css';
import { ErrorMessage } from '@hookform/error-message';
import { HrFlexContainer, HrButtons, HrParagraph, HrRed } from '@components/styles/hr-styles';
import { PropTypes } from 'prop-types';
import { useController } from 'react-hook-form';
import { get } from 'lodash';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

export const InputFile = ({
  name,
  control,
  setValue,
  formState,
  accept,
  inputFile,
  setInputFile,
  inputRef,
  isMultiple,
  validate,
  trigger,
  sizeFiles
}) => {
  const maxSizeFile = sizeFiles || 15000000;
  const { errors } = formState;
  const _validate = {};
  const refCurrent = useRef(null);
  const err = get(errors, name);

  useEffect(() => {
    if (err) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);

  if (validate.required) {
    _validate.required = 'Campo obligatorio';
  }

  if (validate.size) {
    _validate.validate = {
      size: (value) => {
        if (value && value.size > maxSizeFile) {
          return `El tamaño máximo es de ${maxSizeFile/1000000}MB`;
        }
        return true;
      }
    };
    // 'El archivo no puede ser mayor a 15MB';
  }

  if (validate.format) {
    _validate.validate = {
      ...(_validate.validate || {}),
      format: (value) => {
        if (value) {
          const nameValid = value.name;
          const expReg = accept.split(',').map((item) => item.trim());
          const _name = `.${nameValid.split('.').pop()}`;
          if (!expReg.includes(_name)) {
            return 'El formato es invalido';
          }

          return true;
        }
      }
    };
  }

  const { field } = useController({ control, name, rules: _validate });

  useEffect(async () => {
    // TODO: esto esta mal, hay que hacerlo con el useController
    if (inputFile) {
      if (inputFile.file) {
        field.onChange(inputFile.file);
        setValue('cvFileType', inputFile.source, { shouldValidate: true });
        trigger(name);
      }
      // setInputFile(inputFile);
    }
  }, [inputFile]);

  const { darkMode } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' gap='8px' alignItems='flex-start' ref={refCurrent}>
      <HrFlexContainer flexWrap='nowrap'>
        <input
          style={{ display: 'none' }}
          type='file'
          id={name}
          ref={inputRef}
          accept={accept}
          onChange={async (e) => {
            if (inputRef.current.files.length !== 0) {
              const file = e.target.files[0];
              setInputFile({
                name: file.name,
                file,
                source: null,
                type: file.type
              });
            }
          }}
        />

        {!isMultiple && inputFile && inputFile.name !== '' ? (
          <>
            <HrParagraph margin='0' color={darkMode ? 'white' : '' }>{inputFile.name}</HrParagraph>
            <HrButtons
              type='button'
              size='medium'
              category='tertiaryGray'
              onClick={() => {
                if (inputRef) {
                  inputRef.current.value = null;
                  setValue(name, null, { shouldValidate: true });
                }
                setInputFile(null);
              }}
            >
              Eliminar
            </HrButtons>
          </>
        ) : null}
      </HrFlexContainer>

      {!isMultiple && errors[name] && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
        />
      )}
    </HrFlexContainer>
  );
};

InputFile.propTypes = {
  // TODO:revisar caso de uso con el tipo number y value
  name: PropTypes.string,
  value: PropTypes.string,
  validate: PropTypes.object,
  errorPosition: PropTypes.oneOf(['top', 'bottom']),
  accept: PropTypes.string,
  isMultiple: PropTypes.bool,
  handlerChange: PropTypes.func
};

InputFile.defaultProps = {
  name: '',
  value: '',
  validate: {},
  errorPosition: 'top',
  accept: '.pdf, .doc, .docx, .jpg, .jpeg',
  isMultiple: false,
  handlerChange: () => {}
};
